var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedPaymentMethod)?_c('div',[_c('font-awesome-icon',{staticClass:"pr-3",attrs:{"icon":"far fa-money-check"}}),_vm._v("\n    "+_vm._s(_vm.getText)+"\n")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }